import { render, staticRenderFns } from "./Comarca.vue?vue&type=template&id=00e416c8&"
import script from "./Comarca.vue?vue&type=script&lang=js&"
export * from "./Comarca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports